import React from 'react'

const Checked = props => (
  <svg height={16} width={16} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.293 9.04l3.333 3.334c.186.186.444.292.708.292.262 0 .52-.106.706-.292l6.667-6.667a1 1 0 10-1.414-1.414l-5.96 5.96-2.626-2.627A1 1 0 102.293 9.04"
      fill={props.fill || '#fff'}
      fillRule="nonzero"
    />
  </svg>
)

export default Checked
